module.exports = __webpack_public_path__ + "static/media/dynamicDefaultDayDelayAirplane.6507975e.jpg";